// Generated types for TaskHistory
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ThreadReadAPI, ThreadWriteAPI } from '../../chat/types/thread';
import { ThreadReadAPISchemaObject, ThreadWriteAPISchemaObject } from '../../chat/types/thread';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface TaskHistoryReadAPI extends ThreadReadAPI {
}

export interface TaskHistoryWriteAPI extends Omit<ThreadWriteAPI, 'context_items' | 'steps'> {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const TaskHistoryReadAPISchema: z.ZodType<TaskHistoryReadAPI> = ThreadReadAPISchemaObject.extend({}).passthrough();

export const TaskHistoryWriteAPISchema: z.ZodType<TaskHistoryWriteAPI> = ThreadWriteAPISchemaObject.omit({ 'context_items': true, 'steps': true }).extend({}).passthrough();
